import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloneDuotone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30.38,
	height: 25.26,
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#e8e8e8",
		d: "M0 224v224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64v-96h-64v96H64V224h96v-64H64c-35.3 0-64 28.7-64 64"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#008cf6",
		d: "M160 288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64z"
	})]
});
export default SvgCloneDuotone;
